import { Component } from '@angular/core';

/**
 * The Reservations tab of a customer's profile, which hosts two views
 * (PRO-1338):
 *
 * - "Upcoming Reservations" answers "what does this customer have coming up?",
 *   listing the reservations they are the participant on.
 * - "Bookings" answers "what bookings is this customer involved with?", one
 *   row per booking they made or are a participant in.
 *
 * Each is a child route, so a view can be linked to and survives a refresh.
 * This component is just the selector plus the outlet.
 */
@Component({
  selector: 'app-reservations-sub-list',
  templateUrl: './reservations-sub-list.component.html',
  styleUrls: ['./reservations-sub-list.component.css']
})
export class ReservationsSubListComponent {
}
